<script>
    import { format } from "date-fns";
    import { link } from "svelte-routing";

    export let membershipPrint;

    const maxCharNotes = 40;
</script>

<tr class="border-b h-14">
    <td class="w-12">
        <a use:link
           href="/admin/prints/edit/{membershipPrint.id}"
           class="mr-3"
        >
            <span class="w-10 h-10 text-sm border inline-flex items-center justify-center rounded-full cursor-pointer">
                <i class="fa fa-edit"></i>
            </span>
        </a>
    </td>
    <td class="w-32">
        {membershipPrint.code}
    </td>
    <td class="w-32">
        {format(new Date(membershipPrint.date), "dd/MM/yyyy")}
    </td>
    <td class="{membershipPrint?.notes > maxCharNotes ? 'scroll-container' : ''}">
        <div class="{membershipPrint?.notes > maxCharNotes ? 'scroll-text' : ''}">
            {membershipPrint?.notes ?? ""}
        </div>
    </td>
</tr>